import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { ProfileForm } from "../components/ProfileForm";

/** One-time profile setup right after login (new and existing students). Once saved,
 *  profileCompletedAt is set and ProtectedRoute never sends them here again. */
export function WelcomePage() {
  const { user, profile, refreshProfile } = useAuth();
  const navigate = useNavigate();
  const from = (useLocation().state as { from?: { pathname: string } } | null)?.from?.pathname;

  if (!user || !profile) return <p style={{ padding: "3rem", color: "var(--c-text-muted)" }}>กำลังโหลด…</p>;
  if (profile.completed) return <Navigate to="/dashboard" replace />;

  return (
    <main className="container-tight">
      <section className="hero-mint" style={{ marginBottom: "1.5rem" }}>
        <span className="kicker">ยินดีต้อนรับ</span>
        <h1>ตั้งโปรไฟล์ของคุณ</h1>
        <p style={{ color: "var(--c-text-muted)", marginTop: "0.75rem" }}>
          ทำครั้งเดียว ใช้เวลาไม่ถึงนาที ตัวละครกับชื่อนี้จะขึ้นใน Chat โลกและลีดเดอร์บอร์ด แก้ทีหลังได้ที่หน้าโปรไฟล์
        </p>
      </section>
      <ProfileForm
        userId={user.uid}
        initial={{ ...profile, nickname: profile.nickname || user.displayName || "" }}
        submitLabel="เริ่มเรียนเลย →"
        onSaved={async () => {
          await refreshProfile();
          navigate(from && from !== "/welcome" ? from : "/dashboard", { replace: true });
        }}
      />
    </main>
  );
}
